// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right-horizontal{
    text-align: right;
}

.hr-menu{
  width: 200px;
}

.vertical-middle{
  margin-left: 10px;
  margin-top: 13px;
  vertical-align: top;
}

`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
